import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
// Always use relative /api path so it works on preview URL, custom domains, and any deployment
const API = (typeof window !== 'undefined' && window.location.origin)
  ? `${window.location.origin}/api`
  : `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Backwards-compat: still attach a Bearer token if one is found in localStorage
// (older flows / impersonation). The httpOnly cookie set by the server is the
// primary auth mechanism; this is a soft fallback that the server tolerates.
api.interceptors.request.use((config) => {
  const token = typeof window !== 'undefined' ? localStorage.getItem('token') : null;
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
